export default "__VITE_ASSET__0yUg2Uzp__"